/* eslint-disable @typescript-eslint/default-param-last */
import { Reducer } from 'redux';
import { Payouts } from 'store/Collections/Payouts';
import { IStatsState } from 'store/types';
import { Stats } from './types';

const initialState: IStatsState | null = null;

export const statsReducer: Reducer<IStatsState | null> = (state = initialState, action) => {
  switch (action.type) {
    case Stats.GET_SITE_PAYOUT_STATS_REQUEST:
    case Stats.GET_EMPLOYEE_PAYOUT_STATS_REQUEST:
    case Stats.GET_USER_PAYOUT_STATS_REQUEST: {
      return {
        ...state,
        payouts: null,
      };
    }
    case Stats.GET_SITE_PAYOUT_STATS_SUCCESS:
    case Stats.GET_EMPLOYEE_PAYOUT_STATS_SUCCESS:
    case Stats.GET_USER_PAYOUT_STATS_SUCCESS: {
      return {
        ...state,
        payouts: action.payload,
      };
    }
    case Stats.GET_USER_PAYOUT_STATS_BY_DATE_SUCCESS: {
      // Merge byDate data with existing payouts data to preserve byStatus and byParticipant
      return {
        ...state,
        payouts: state?.payouts
          ? {
              ...state.payouts,
              byDate: action.payload?.byDate || [],
              // Preserve byStatus and byParticipant from existing state if they exist and have data
              byStatus: state.payouts.byStatus?.length ? state.payouts.byStatus : action.payload?.byStatus || [],
              byParticipant: state.payouts.byParticipant?.length ? state.payouts.byParticipant : action.payload?.byParticipant || [],
            }
          : action.payload,
      };
    }
    case Payouts.GET_SITE_REVIEW_PAYOUTS_COUNT_REQUEST: {
      return {
        ...state,
        counts: {
          ...state?.counts,
          reviewPayouts: null,
        },
      };
    }
    case Payouts.GET_SITE_REVIEW_PAYOUTS_COUNT_SUCCESS:
    case Payouts.GET_SITE_REVIEW_PAYOUTS_SUCCESS: {
      const { total } = action.payload;
      return {
        ...state,
        counts: {
          ...state?.counts,
          reviewPayouts: total,
        },
      };
    }
    default: {
      return state;
    }
  }
};
